import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BRAND_LOGO_KU, INSTAGRAM_URL } from "../lib/pulaar";

export default function Footer() {
  const year = new Date().getFullYear();
  const { t } = useTranslation();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#FBF8EF] border-t border-[#E5DFD3] font-sans"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16 py-8 flex flex-col md:flex-row items-center md:items-baseline justify-between gap-4 text-[11px] tracking-[0.22em] uppercase text-[#4A4641]">
        <p className="order-3 md:order-1">© {year} Pulaar</p>
        <nav className="order-1 md:order-2 flex flex-wrap items-center justify-center gap-x-7 gap-y-2">
          <Link to="/contact" className="nav-link" data-testid="footer-contact-link">{t("nav.contact")}</Link>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="nav-link"
            data-testid="footer-instagram-link"
          >
            Instagram
          </a>
          <a
            href="mailto:info@pulaar.co"
            className="nav-link"
            data-testid="footer-email-link"
          >
            info@pulaar.co
          </a>
          <Link to="/mentions-legales" className="nav-link" data-testid="footer-legal-link">{t("footer.legal")}</Link>
        </nav>
        <span
          className="order-2 md:order-3 hidden md:inline-flex items-center"
          data-testid="footer-brand-logo"
          aria-label="Pulaar"
        >
          <img
            src={BRAND_LOGO_KU}
            alt="Pulaar"
            className="h-7 w-auto opacity-80"
            loading="lazy"
          />
        </span>
      </div>
    </footer>
  );
}
